resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function FileUpload() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    // Parameters
    this.url = "";
    this.urlMethod = "POST";
    this.parameterName = "";
    this.autoSubmit = false;
    this.maxUploads = 1; // 1 to 20
    this.maxSize = 1024; //in KB
    this.supportedTypes = [];
    this.progressSupport = true;
    this.apiVersion = 2; // 1 for BL, 2 for API
    this.initialData = null;
    this.allowDelete = true;
    this.data = null;
    this.ctasCopy = {
      upload: "upload file",
      select: "select file"
    };
    this.onComplete = function() {};
    this.onSizeError = null;
    this.onFormatError = null;
    this.onUploadError = null;
    this.onSelection = function() {};
    this.onSelectionDelete = function() {};
    this.onFileDelete = function() {};
    this.onDeleteEventRequest = function(callback){callback()};

    this._uploaders = new Object();
    this._uploadOuterContainer = null;
    this._uploaderContainer = null;
    this._uploadFilesBtn = null;
    this._complete = null;
    this._runningIndex = -1;
    this._uploading = false;

    this.init = function() {
        // Set class
        $(this.node).addClass("mogo-ui-file-upload");

        // Set max uploads limit
        this.maxUploads = Math.max(this.maxUploads, 1);
        this.maxUploads = Math.min(this.maxUploads, 20);

        // Complete array
        this._complete = new Object();

        // Upload outer container
        this._uploadOuterContainer = $("<div class='upload-outer-container'></div>");
        $(this.node).append(this._uploadOuterContainer);

        // Uploader container
        this._uploaderContainer = $("<div class='uploader-container'></div>");
        $(this._uploadOuterContainer).append(this._uploaderContainer);

        // Upload Button
        this._uploadFilesBtn = $("<a>")[0];
        $(this._uploadFilesBtn).attr("id", this.id + "-upload-files");
        $(this._uploadFilesBtn).attr("class", "btn primary upload-files");
        $(this._uploadFilesBtn).attr("href", "#");
        $(this._uploadFilesBtn).html("Upload Selected Files");
        $(this._uploadOuterContainer).append(this._uploadFilesBtn);
        $(this._uploadFilesBtn).on("click", $.proxy(this.uploadFiles, this));

        // Set initial data
        if (this.initialData != null)
            this._setInitialData(this.initialData);

        // Upload files button
        if (!this.autoSubmit && this._getPendingUploads() > 0)
            $("#" + this.id + "-upload-files").css("display", "inline-block");

        // Add uploader
        this._addUploader();
    };

    this.initAllReady = function() {
        $(this.node).css("display", "block");
    };

    /* For autoSubmit = false */
    this.uploadFiles = function() {
        this._uploading = true;

        // IE specific
        if ($("html").hasClass("ie9")) {
            $("#" + this.id + " " + " .progress-indicator").css("width", "100%");
        }

        this._uploading = true;

        // Hide unneccessary elements

        // Hide upload files button
        $(this._uploadFilesBtn).css("display", "none");

        // Remove last uploader if no file selected
        if (!$(".file-container", this.node).last().hasClass("file-selected")) {
            var index = $(".file-container", this.node).last()[0].id.substring((this.id + "-upload-container-").length);
            this._removeUploader(index);
            delete this._complete[index];
        }

        // Remove old files
        this._removeErroredFiles();

        for (var key in this._complete) {
            if (this._complete[key].file != null && this._complete[key].status == null) {
                // Hide delete icons
                $("#" + this.id + "-upload-container-" + this._complete[key].index + " .icon-delete", this.node).css("display", "none");
                this._uploaders[this._complete[key].index].submit();
            }
        }
        return false;
    };

    this._addUploader = function() {
        var count = 0;
        var alreadyExists = false;
        for (var key in this._complete) {
            if (this._complete[key].status === true || this._complete[key].status === null) {
                count++;
            }
            if (this._complete[key].status === null) {
                // Empty uploader exists
                return false;
            }
        }
        if (count >= this.maxUploads)
            return false;

        this._runningIndex++;
        var index = this._runningIndex;

        this._complete[index] = {
            status: null,
            file: null,
            index: index
        };

        // Create container
        var container = $("<div>");
        $(container).attr("id", this.id + "-upload-container-" + index);
        $(container).addClass("file-container");
        $(this._uploaderContainer).append(container);

        var button = null;
        if (Object.keys(this._complete).length <= 1) {
            // Select Files button
            button = $("<a>")[0];
            $(button).attr("id", this.id + "-select-" + index);
            $(button).attr("class", "btn secondary choose-file");
            $(button).attr("href", "#");
            if (this.autoSubmit)
                $(button).html(this.ctasCopy.upload);
            else
                $(button).html(this.ctasCopy.select);
            $(container).append(button);
        } else {
          button = $("<a>")[0];
          $(button).attr("id", this.id + "-select-" + index);
          $(button).attr("href", "#");
            if (this.maxUploads > 1) {
              // Add more files button
              $(button).attr("class", "btn secondary choose-file more-files");
              if (this.autoSubmit) {
                $(button).html("Upload More Files");
              } else {
                $(button).html("Add More Files");
              }
            } else {
              // Select Files button
              $(button).attr("class", "btn secondary choose-file");
              if (this.autoSubmit)
                  $(button).html(this.ctasCopy.upload);
              else
                  $(button).html(this.ctasCopy.select);
            }
            $(container).append(button);
        }

        // Add cancel button
        var cancelBtn = $('<a href="#" class="icon-delete" title="Delete File"><svg viewBox="0 0 32 32" id="icon-delete" width="100%" height="100%"><title>Delete file</title><path d="M21.612.97v2.908h-1.938V1.94h-7.759v1.938H9.977V0h11.636v.969zm6.647 7.46h3.131V5.603H.28v2.828h3.131L5.936 32h19.797L28.26 8.431zm-2.845.001L23.19 29.185l-14.7-.011-2.234-20.74 19.157-.004z"></path></svg></a>');
        $(cancelBtn).attr("id", this.id + "-cancel-" + index);
        $(container).append(cancelBtn);
        $(cancelBtn).on("click", this.onDeleteEventRequest.bind(this, this._removeFile.bind(this), index));

        // Add progress indicator
        if (this.progressSupport == true) {
            var indicator = $("<div>");
            $(indicator).addClass("progress-indicator");
            $(container).append(indicator);
        } else {
            var indicator = $("<div>");
            $(indicator).addClass("progress-infinite");
            $(container).append(indicator);
        }

        // Add success icon
        var successIcon = $('<svg viewBox="0 0 32 32" class="icon-ticker2" id="icon-ticker2" width="100%" height="100%"><path d="M14.054 29.622L.865 16.865l3.243-3.459 9.297 8.865L27.243 2.379l3.892 2.595z"></path></svg>');
        $(container).append(successIcon);

        // Add error icon
        var errorIcon = $("<span>");
        $(errorIcon).addClass("icon--warning");
        $(container).append(errorIcon);

        // Add draggable overlay
        var draggable = $("<div>");
        $(draggable).addClass("draggable-overlay");
        $(container).append(draggable);
        var icon = $("<span>");
        $(icon).addClass("icon-download");
        $(draggable).append(icon);

        var apiHeader = "";
        if (this.apiVersion == 1) apiHeader = mogo.registry.mogoUI.config.blAcceptHeader;
        else if (this.apiVersion == 2) apiHeader = mogo.registry.mogoUI.config.apiAcceptHeader;

        var uploader = new ss.SimpleUpload({
            button: button.id,
            url: this.url,
            method: this.urlMethod,
            name: this.parameterName,
            allowedExtensions: this.supportedTypes,
            customHeaders: {
                "Accept": apiHeader,
                "Content-Disposition": "form-data",
                "X-Auth-Token": Cookies.get("X-Auth-Token")
            },
            autoSubmit: this.autoSubmit,
            maxSize: this.maxSize,
            queue: false,
            multipart: true,
            responseType: "json",
            data: this.data,
            dropzone: this.id + '-upload-container-' + index,
            dragClass: 'draggable',
            onChange: $.proxy(this._onChange, this, index),
            onSubmit: $.proxy(this._onSubmit, this, index),
            onProgress: $.proxy(this._onProgress, this, index),
            onComplete: $.proxy(this._onComplete, this, index),
            onError: $.proxy(this._onError, this, index),
            startXHR: $.proxy(this._startXHR, this, index),
            startNonXHR: $.proxy(this._startNonXHR, this, index),
            endNonXHR: $.proxy(this._endNonXHR, this, index),
            debug: false
        });
        this._uploaders[index] = uploader;
    };

    this._removeUploader = function(index) {
        delete this._uploaders[index];
        $("#" + this.id + "-upload-container-" + index).remove();
    };

    this._onChange = function(index, filename, extension, uploadBtn) {
        if (this._uploading) return false;

        // File selected?
        var previouslySelected = $("#" + this.id + "-upload-container-" + index).hasClass("file-selected");

        // Check extension
        extension = extension.toLowerCase();
        var failed = true;
        for (var i = 0; i < this.supportedTypes.length; i++) {
            if (extension == this.supportedTypes[i].toLowerCase()) {
                failed = false;
                break;
            }
        }

        var uploader = this._uploaders[index];

        if (failed) { uploader._input.value = ""; this._onExtError(); return false; }

        // Check size, if possible
        if (uploader._input && uploader._input.files && uploader._input.files[0] && uploader._input.files[0].size) {
            var size = (uploader._input.files[0].size)/1024; // in KB
            if (size > this.maxSize) {
                this._onChangeMaxSizeError();
                return false;
            }
        }

        // Show added file
        $("#" + this.id + "-upload-container-" + index + " a.choose-file").html(filename);
        $("#" + this.id + "-upload-container-" + index).addClass("file-selected");
        setTimeout($.proxy(function(){$(uploader._input).attr("title", filename);}, this), 500);

        // Add to complete
        this._complete[index]["file"] = filename;

        // Remove error files, set status as true
        if (this.autoSubmit) {
            this._complete[index]["status"] = true;
            this._removeErroredFiles();
            $("#" + this.id + "-upload-container-" + index + " .icon-delete").css("display", "none");
        }

        // Add new uploader
        if (!previouslySelected)
            this._addUploader();

        // Show Upload Files button if not already shown
        if (!this.autoSubmit && this._getPendingUploads() > 0) {
            $("#" + this.id + "-upload-files").slideDown(500);
            setTimeout($.proxy(this.onSelection, null, index), 500);
        } else {
            // Callback
            this.onSelection(index);
        }
        // analytics tracking
        dataLayer.push({
          'event' : 'DLevent.FileUploadComponent',
          'type' : 'File Selection'
        });
    };

    this._removeFile = function(index, e) {
        if ($(e.currentTarget).data("delete")) {
            if ($(e.currentTarget).hasClass("deleting"))
                return false;
            $(e.currentTarget).addClass("deleting");
            var link = $(e.currentTarget).data("delete");
            var delReq = new APIRequest(link, "DELETE", null, $.proxy(this._onServerDelete, this, index));
            delReq.send();
            return false;
        }

        this._removeUploader(index);

        delete this._complete[index];
        if ($(".file-container", this.node).length == $(".file-selected", this.node).length) {
            this._addUploader();
        } else if (Object.keys(this._complete).length == 1) {
            $(".choose-file", this.node).removeClass("more-files");
            if (this.autoSubmit)
                $(".choose-file", this.node).last().html(this.ctasCopy.upload);
            else
                $(".choose-file", this.node).last().html(this.ctasCopy.select);
        }

        if (!this.autoSubmit && this._getPendingUploads() == 0)
            $("#" + this.id + "-upload-files").css("display", "none");

        // Callback
        this.onSelectionDelete(index);

        return false;
    };

    this._onSubmit = function(index, filename, extension) {};

    this._startXHR = function(index, filename, filesize) {
        $("#" + this.id + "-upload-container-" + index + " input").attr("disabled", true);
        $("#" + this.id + "-upload-container-" + index).addClass("processing");
        $("#" + this.id + "-upload-container-" + index + " .progress-indicator").css("width", "1%");
        if (this.progressSupport)
            $("#" + this.id + "-upload-container-" + index + " .choose-file").css("padding-left", "10px");
    };

    this._startNonXHR = function(index, filename, uploadBtn) {
        $("#" + this.id + "-upload-container-" + index + " input").attr("disabled", true);
        $("#" + this.id + "-upload-container-" + index).addClass("processing");
        $("#" + this.id + "-upload-container-" + index + " .progress-indicator").css("width", "100%");
        if (this.progressSupport)
            $("#" + this.id + "-upload-container-" + index + " .choose-file").css("padding-left", "10px");
    };

    this._endNonXHR = function(filename, uploadBtn) {

    };

    this._onProgress = function(index, pct) {
        if (!$("html").hasClass("ie9"))
            $("#" + this.id + "-upload-container-" + index + " .progress-indicator").css("width", pct + "%");
    };

    this._onComplete = function(index, filename, response) {
        if (this.apiVersion == 2) {
            if (response.polling_url) {
                var apiReq = new APIRequest(response.polling_url, "GET", null, $.proxy(this._onComplete, this, index, filename));
                apiReq.send();
                return;
            }
        }

        if (typeof response == "string" && response.indexOf("Error") > 0) {
            this._complete[index].status = false;
            $("#" + this.id + "-upload-container-" + index).addClass("error");
            this.onUploadError(index, filename, "error", 0, "", response);
        } else if (response.errors) {
            this._complete[index].status = false;
            $("#" + this.id + "-upload-container-" + index).addClass("error");
            this.onUploadError(index, filename, "error", 0, "", response);
        } else {
            this._complete[index].status = true;
            $("#" + this.id + "-upload-container-" + index).addClass("success");
            $("#" + this.id + "-upload-container-" + index).removeClass("processing");

            // Remove uploader but keep in view
            $("#" + this.id + "-upload-container-" + index + " input").remove();
            $("#" + this.id + "-upload-container-" + index).addClass("disabled");
            delete this._uploaders[index];

            // Delete button
            if (this.apiVersion == 2 && this.allowDelete && response.links) {
                if (this.maxUploads > 1) {
                  console.warn("BE API doesn't currently support multi-file uploading, this will likely fail");
                  for (var i = response.uploaded_file.length - 1; i >= 0; i--) {
                      var file = response.uploaded_file[i];
                      if ($("#" + this.id + "-select-" + index).text() == file.file_name) {
                          $("#" + this.id + "-upload-container-" + index + " .icon-delete").css("display", "block");
                          $("#" + this.id + "-upload-container-" + index + " .icon-delete").data("delete", file.links[0].uri);
                          break;
                      }
                  }
                } else {
                  var file = response.uploaded_file;
                  if ($("#" + this.id + "-select-" + index).text() === file.file_name) {
                      $("#" + this.id + "-upload-container-" + index + " .icon-delete").css("display", "block");
                      for (i = 0; i <  response.links.length; i++) {
                          if (response.links[i].method === 'DELETE') {
                              $("#" + this.id + "-upload-container-" + index + " .icon-delete").data("delete", response.links[i].uri);
                              break;
                          }
                      }
                  }
                }
            }
            dataLayer.push({
              'event' : 'DLevent.FileUploadComponent',
              'type' : 'Validation Success'
            });
        }

        // All completed?
        if (!this.autoSubmit) {
            for (var key in this._complete) {
                if (this._complete[key].status == null)
                    return;
            }
            this._uploading = false;
        }
        this._addUploader();
        this._onAllComplete(this._complete, response);
    };

    this._onAllComplete = function(result, response) {
      // removing timeout as there's no apparent reason for it, keeping for now
      // in case of regression, remove in the future if not needed
      // setTimeout($.proxy(this.onComplete, null, result, response), 800);
      this.onComplete(result, response);
    };

    this._onError = function(index, filename, errorType, status, statusText, response, uploadBtn) {
        this._complete[index].status = false;
        $("#" + this.id + "-upload-container-" + index).addClass("error");

        // Remove uploader but keep in view
        $("#" + this.id + "-upload-container-" + index + " input").remove();
        $("#" + this.id + "-upload-container-" + index).addClass("disabled");
        delete this._uploaders[index];

        // Switch uploading to false if all complete
        if (!this.autoSubmit) {
            for (var key in this._complete) {
                if (this._complete[key].status == null)
                    return;
            }
            this._uploading = false;
        }

        // Add new uploader
        this._addUploader();

        this.onUploadError(index, filename, errorType, status, statusText, response);

        dataLayer.push({
          'event' : 'DLevent.FileUploadComponent',
          'type' : 'Validation Error',
          'errorNotificationContent' : 'Error: File failed to upload'
        });
    };

    this._onExtError = function() {
        var types = this.supportedTypes.join(", ").toUpperCase();
        types = types.substring(0, types.lastIndexOf(",")) + " or" + types.substring(types.lastIndexOf(",") + 1);
        if (this.onFormatError) {
          this.onFormatError(types);
        } else {
          var description = "File format is not supported, please select a supported file format (" + types + ").";
          alert(description);
        }
        dataLayer.push({
          'event' : 'DLevent.FileUploadComponent',
          'type' : 'Validation Error',
          'errorNotificationContent' : 'Error: File format not supported'
        });
    };

    this._onChangeMaxSizeError = function() {
      var maxSize = Math.round(this.maxSize / 1024 * 10)/10 + " MB";
      if (this.onSizeError) {
        this.onSizeError(maxSize);
      } else {
        alert("File could not be selected. File size is too large, please select a file no larger than " + maxSize + ".");
      }
      dataLayer.push({
        'event' : 'DLevent.FileUploadComponent',
        'type' : 'Validation Error',
        'errorNotificationContent' : 'Error: File size is too large'
      });
    };

    this._getPendingUploads = function() {
        if (this._complete) {
            var count = 0;
            for (var key in this._complete) {
                if (this._complete[key].file != null && this._complete[key].status == null)
                    count++;
            }
            return count;
        }
        return 0;
    };

    this._removeErroredFiles = function() {
        var errFiles = $(".file-selected.error", this.node);
        for (var i = 0; i < errFiles.length; i++) {
            var index = errFiles[i].id.substring((this.id + "-upload-container-").length);
            delete this._complete[index];
            $(errFiles[i]).remove();
        }
    };

    this._onServerDelete = function(index, response, status) {
        if (response && status === 200) {
            delete this._complete[index];
            $("#" + this.id + "-upload-container-" + index + " .icon-delete").addClass("deleted");
            $("#" + this.id + "-upload-container-" + index).removeClass("success");
            var i = index;
            if (this.maxUploads === 1) {
              $("#" + this.id + "-upload-container-" + index).remove();
            } else {
              $("#" + this.id + "-upload-container-" + index).slideUp(325, $.proxy(function(ind) {
                  $("#" + this.id + "-upload-container-" + ind).remove();
              }, this, i));
            }
            if ($(".file-container", this.node).length == $(".file-selected", this.node).length) {
                this._addUploader();
            } else if (Object.keys(this._complete).length == 1) {
                $(".choose-file", this.node).removeClass("more-files");
                if (this.autoSubmit)
                    $(".choose-file", this.node).last().html(this.ctasCopy.upload);
                else
                    $(".choose-file", this.node).last().html(this.ctasCopy.select);
            }

            // Callback
            setTimeout($.proxy(this.onFileDelete, null, index), 350);

            dataLayer.push({
              'event' : 'DLevent.FileUploadComponent',
              'type' : 'Delete'
              });
        } else {
            $("#" + this.id + "-upload-container-" + index + " .icon-delete").removeClass("deleting");
            alert("Error: could not delete file");

            dataLayer.push({
              'event' : 'DLevent.FileUploadComponent',
              'type' : 'Validation Error',
              'errorNotificationContent' : 'Error: File failed to delete'
            });
        }
    };

    /* data should be "uploads" object */
    this._setInitialData = function(fileArray) {
        if (this.apiVersion == 2) {
            for (var i = 0; i < fileArray.length; i++) {
                var file = fileArray[i];
                this._runningIndex++;
                var index = this._runningIndex;

                this._complete[index] = {
                    status: true,
                    file: file.original_file_name,
                    index: index
                };

                // Create container
                var container = $("<div>");
                $(container).attr("id", this.id + "-upload-container-" + index);
                $(container).addClass("file-container file-selected success disabled");
                $(this._uploaderContainer).append(container);

                // Upload module
                var uploadModule = $("<div>");
                uploadModule.addClass("upload-module");
                $(container).append(uploadModule);
                uploadModule.css('display', 'flex');

                // File name
                var fileName = $("<a>");
                fileName.attr("id", this.id + "-select-" + index);
                fileName.attr("href", "#");
                fileName.attr("tabindex", "-1");
                fileName.addClass("btn secondary choose-file more-files");
                fileName.html(file.uploaded_file.file_name);
                $(fileName).on("click", function() {return false});
                $(uploadModule).append(fileName);

                // Add cancel button
                var cancelBtn = $('<a href="#" class="icon-delete" title="Delete File"><svg viewBox="0 0 32 32" id="icon-delete" width="100%" height="100%"><title>Delete file</title><path d="M21.612.97v2.908h-1.938V1.94h-7.759v1.938H9.977V0h11.636v.969zm6.647 7.46h3.131V5.603H.28v2.828h3.131L5.936 32h19.797L28.26 8.431zm-2.845.001L23.19 29.185l-14.7-.011-2.234-20.74 19.157-.004z"></path></svg></a>');
                $(cancelBtn).attr("id", this.id + "-cancel-" + index);
                $(container).append(cancelBtn);
                $(cancelBtn).on("click", this.onDeleteEventRequest.bind(this, this._removeFile.bind(this), index));

                if (file.links[0].method == "DELETE") {
                    $(cancelBtn).data("delete", file.links[0].uri);
                }

                // Add progress indicator
                if (this.progressSupport == true) {
                    var indicator = $("<div>");
                    $(indicator).addClass("progress-indicator");
                    $(container).append(indicator);
                } else {
                    var indicator = $("<div>");
                    $(indicator).addClass("progress-infinite");
                    $(container).append(indicator);
                }

                // Add success icon
                var successIcon = $('<svg viewBox="0 0 32 32" class="icon-ticker2" id="icon-ticker2" width="100%" height="100%"><path d="M14.054 29.622L.865 16.865l3.243-3.459 9.297 8.865L27.243 2.379l3.892 2.595z"></path></svg>');
                $(container).append(successIcon);

                // Add error icon
                var errorIcon = $("<span>");
                $(errorIcon).addClass("icon--warning");
                $(container).append(errorIcon);

                // Add draggable overlay
                var draggable = $("<div>");
                $(draggable).addClass("draggable-overlay");
                $(container).append(draggable);
                var icon = $("<span>");
                $(icon).addClass("icon-download");
                $(draggable).append(icon);
            }
        }
    }
}
